import React from "react";
import SocialMediaBar from "./socialMediaBar";

const SubscribeWidget = ({ showLabel = true }) => {
  return (
    <div className="subscribe-widget-container">
      <form
        action="https://subscribe.wordpress.com"
        method="post"
        acceptCharset="utf-8"
        className="d-flex flex-wrap gap-2"
        data-blog="5252229"
        data-post_access_level="everybody"
        id="subscribe-blog"
      >
        <div id="subscribe-input-container">
          {showLabel && (
            <p className="subscribe-widget-label">
              <small>Subscribe for latest updates</small>
            </p>
          )}
          <input
            className="subscribe-widget-input form-control"
            type="email"
            name="email"
            placeholder="Subscribe by Email"
            id="subscribe-field"
          />
        </div>
        <div className="subscribe-submit">
          <input type="hidden" name="action" value="subscribe" />
          <input type="hidden" name="blog_id" value="5252229" />
          <input
            type="hidden"
            name="source"
            value="https://beingrefactored.com/"
          />
          <input type="hidden" name="sub-type" value="widget" />
          <input
            type="hidden"
            name="redirect_fragment"
            value="subscribe-blog"
          />
          <input
            type="hidden"
            id="_wpnonce"
            name="_wpnonce"
            value="8e9a3b2266"
          />
          <button
            type="submit"
            className="btn btn-secondary subscribe-widget-button"
          >
            Subscribe
          </button>
        </div>
      </form>
      <div style={{ marginLeft: "-2rem" }}>
        <SocialMediaBar />
      </div>
    </div>
  );
};

export default SubscribeWidget;
